<template>
  <div class="json-view">
    <TnButton
      v-if="copyable"
      class="json-view-copy"
      size="s"
      secondary
      compact
      :text="copied ? 'Copied' : 'Copy'"
      @click="copy"
    />
    <pre class="json-view-code">{{ formatted }}</pre>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { TnButton } from '@telenornorgeinternal/telegrafen-vue3-core';

const props = defineProps<{ value: unknown; copyable?: boolean }>();

const copied = ref(false);

const formatted = computed(() => JSON.stringify(props.value, null, 2));

async function copy() {
  await navigator.clipboard.writeText(formatted.value);
  copied.value = true;
  setTimeout(() => (copied.value = false), 2000);
}
</script>

<style scoped>
.json-view {
  position: relative;
}

.json-view-copy {
  position: absolute;
  top: 8px;
  right: 8px;
}

.json-view-code {
  overflow-x: auto;
  padding: 16px;
  border-radius: 6px;
  background-color: #fafafa;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  line-height: 1.625;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
</style>
